import { createClient } from "@supabase/supabase-js";

// 1. Create a free project at https://supabase.com
// 2. Project Settings -> API Keys -> "Publishable and secret API keys" tab
//    (older projects may still show this as "Project URL" + "anon public" key —
//    that's the previous naming for the same thing)
// 3. Copy the Project URL from Project Settings -> Data API, and the key
//    starting with sb_publishable_... (or the "anon" key on older projects
//    ) from Project Settings -> API Keys. Paste both below.
// 4. Run supabase-schema.sql (in the project root) in Supabase's SQL Editor
//
// IMPORTANT: only ever put the PUBLISHABLE key here — sb_publishable_... (or
// the legacy "anon" key). Never the SECRET key, sb_secret_... (or the legacy
// "service_role" key) — that one bypasses all data-access rules and must
// only ever live on a server you control, never in code that ships to a
// browser. This file is public the moment it's built and deployed.
const SUPABASE_URL = "https://bsmboamvwlpczxeyesaw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_Tk7vjFMhlTAV2ySFyZNLFQ_6uqyi1VX";

const looksLikeSecretKey = SUPABASE_PUBLISHABLE_KEY.startsWith("sb_secret_");

if (looksLikeSecretKey) {
  // Don't crash the app over this — just refuse to use it, log why, and let
  // the Account screen explain it on-screen too (see configWarning below).
  console.error(
    "supabaseClient.js: a SECRET key (sb_secret_...) is in the PUBLISHABLE key slot. " +
    "Sync has been disabled to avoid shipping it to the browser. Replace it with the key " +
    "starting sb_publishable_... from Supabase's API Keys settings."
  );
}

// Shown on the Account screen when something's set up wrong, so the problem
// is visible in the app itself and not just in a console nobody's looking at.
export const configWarning = looksLikeSecretKey
  ? "A Supabase SECRET key is pasted where the PUBLISHABLE key belongs, in src/supabaseClient.js. Sync is disabled until that's fixed — swap in the key starting sb_publishable_... instead."
  : null;

export const syncConfigured = !looksLikeSecretKey && SUPABASE_URL.startsWith("http") && !SUPABASE_PUBLISHABLE_KEY.startsWith("YOUR_");

// Until this is configured correctly, `supabase` stays null and every
// account/sync feature quietly disables itself — the app keeps working
// fully offline exactly as it does today. Nothing about local-only use
// depends on this file.
export const supabase = syncConfigured ? createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY) : null;
